import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { FormAlert } from '../../../../__legacy__/components/FormAlert';
import { IJobDetailsService } from '../../jobDetails.service';
import { withValidType } from './withValidType';

export const GlobalValidationErrorsContainer = withValidType(
  observer((): ReactElement => {
    const jobDetailsService = useInjection(IJobDetailsService.$);

    const {
      getGlobalErrors,
      store: { validationErrors },
    } = jobDetailsService;
    const errors = getGlobalErrors();

    return (
      <>
        {validationErrors.showAll &&
          Array.from(errors.entries()).map(([tab, error]) => (
            <FormAlert
              key={tab}
              errors={error}
            />
          ))}
      </>
    );
  })
);
